<template>
  <header :class="{'transparent': transparentHeader }">
    <div class="black-bar hidden-on-mobile hidden-on-tablet">&nbsp;</div>

    <InfoBanner />

    <QuickSearch v-on:hide-search="hideSearch" :isShowSearch="isShowSearch" />

    <UpperHeader>
      <Hamburger v-on:show-modal="showModal" :classes="classes" />
    </UpperHeader>

    <ResponsiveNav v-show="isModalVisible" @close="closeModal" v-on:show-modal="showModal" />

    <LowerHeader
      :scroll="handleScroll"
      :isLowerFixed="isLowerFixed"
      v-on:show-quick-search="showSearch"
    />
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
import ProcessLiquid from '../../mixins/ProcessLiquid.js'
import Hamburger from '../atoms/Hamburger.vue'
import ResponsiveNav from '../atoms/ResponsiveNav.vue'
import UpperHeader from '../molecules/UpperHeader.vue'
import LowerHeader from '../molecules/LowerHeader.vue'
import QuickSearch from '../molecules/QuickSearch.vue'
import InfoBanner from '../molecules/InfoBanner.vue'

export default {
  mixins: [ProcessLiquid],
  components: {
    ResponsiveNav,
    Hamburger,
    QuickSearch,
    UpperHeader,
    LowerHeader,
    InfoBanner,
  },
  data() {
    return {
      isModalVisible: false,
      classes: 'hamburger-container hidden-on-desktop',
      isLowerFixed: false,
      isShowSearch: false,
      transparentHeaderData: 'liquid:homepage.transparent-header',
    }
  },
  computed: mapGetters(['wishlistCount']),
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  computed: {
    transparentHeader: function() {
      return this.transparentHeaderData ? this.transparentHeaderData.transparentHeader : false
    },
  },
  methods: {
    showModal: function(show) {
      this.isModalVisible = show
      this.classes = show
        ? 'hamburger-container close hidden-on-desktop'
        : 'hamburger-container hidden-on-desktop'

      if (show) {
        document.body.classList.add('noscroll')
        document.documentElement.classList.add('noscroll')
      } else {
        document.body.classList.remove('noscroll')
        document.documentElement.classList.remove('noscroll')
      }
    },
    closeModal() {},
    showSearch() {
      this.isShowSearch = true
    },
    hideSearch: function() {
      this.isShowSearch = false
    },
    handleScroll(event) {
      if (document.documentElement.scrollTop > 58) {
        this.isLowerFixed = true
      } else {
        this.isLowerFixed = false
      }
    },
  },
}
</script>
